import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { map } from 'rxjs/operators';

import { AdminService } from '@core/services/admin.service';

export const adminGuard: CanActivateFn = () => {
  const adminService = inject(AdminService);
  const router = inject(Router);

  return adminService.checkAdminStatus(true).pipe(
    map(response => (response.isAdmin ? true : router.createUrlTree(['/'])))
  );
};
